import React, { Component } from 'react';
import { Card } from "@inspinia-react"
import { api, get, consts } from '@config'
import Pagination from '@inspinia-react/pagination'

class DashBoardAccountant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                total_of_clients: 0,
                total_of_certificates: 0,
                certificates: []
            }
        }
    }

    UNSAFE_componentWillMount() {
        const url = `${api.users.getAccountantInfo}?`
        const payload = data => {
            this.setState({ data })
        }
        const errPayload = err => {
        }

        get(url, payload, errPayload)
    }


    render() {
        return (
            <div className='container-fluid'>
                <div className="d-flex flex-lg-row flex-column">
                    <Card label={"Clientes"} total={this.state.data.total_of_clients} isNotCurrency />
                    <Card label={"Total de Certificados"} total={this.state.data.total_of_certificates} isNotCurrency ></Card>
                    <Card label={"Vencimento esse mês"} total={this.state.data.certificates.length} isNotCurrency ></Card>
                </div> 
            </div>
        );
    }
}

export default DashBoardAccountant;


// WEBPACK FOOTER //
// ./src/components/pages/accountant/home/index.jsx